import { useMemo } from 'react';
import { useParams } from 'react-router';
import { mapValues } from 'lodash';
import { FORM_ENTITY_IDS_PARAM_NAME } from 'modules/campaigns/config/routes';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData/FormDataContext';
import { getParams } from '../utils/getParams';

const COMMA_SEPARATED_PARAMS = new Set([FORM_ENTITY_IDS_PARAM_NAME]);
const LIST_SEPARATOR = ',';

const processParamsValues = params =>
    mapValues(params, (value, key) => (COMMA_SEPARATED_PARAMS.has(key) ? value?.split(LIST_SEPARATOR) : value));

export const useMultiLayerPathParams = (customPath, customPattern) => {
    const { path: formPath, pattern: formPattern } = useFormDataContext();

    const path = customPath || formPath;
    const pattern = customPattern || formPattern;

    const isMultiLayerDrawerEnabled = useConfigMatch({ [FEATURE_FLAGS.MULTI_LAYER_DRAWER_ENABLED]: 'true' });
    const params = useParams();

    const customizedParams = useMemo(() => {
        if (!isMultiLayerDrawerEnabled) {
            return processParamsValues(params);
        }

        const patternParams = getParams(path, pattern);
        return processParamsValues(patternParams);
    }, [params, path, pattern, isMultiLayerDrawerEnabled]);

    return customizedParams;
};
